import clsx from 'clsx';
import PropTypes from 'prop-types';

import Tag from 'honeydew/Tag';

function ProductTags({ acquisitionPDP, attributes, sourcingReason }) {
    const tagBg = acquisitionPDP ? 'offWhite' : 'white';
    if (sourcingReason || attributes?.length > 0) {
        return (
            <div className={clsx('flex flex-wrap gap-10', { 'my-30': acquisitionPDP })}>
                {sourcingReason && (
                    <Tag bgColor={tagBg} bold={false} variant="dark">
                        <div className="flex items-center gap-[2px] whitespace-nowrap">{sourcingReason}</div>
                    </Tag>
                )}
                {attributes?.map((attribute) => (
                    <Tag bgColor={tagBg} bold={false} key={attribute} variant="dark">
                        {attribute}
                    </Tag>
                ))}
            </div>
        );
    }

    return null;
}

ProductTags.propTypes = {
    acquisitionPDP: PropTypes.bool,
    attributes: PropTypes.arrayOf(PropTypes.string),
    sourcingReason: PropTypes.string,
};

ProductTags.defaultProps = {
    acquisitionPDP: false,
    attributes: [],
    sourcingReason: null,
};

export default ProductTags;
